import { render, staticRenderFns } from "./Category-Form.vue?vue&type=template&id=2797d3b2&scoped=true"
import script from "./Category-Form.vue?vue&type=script&lang=js"
export * from "./Category-Form.vue?vue&type=script&lang=js"
import style0 from "./Category-Form.vue?vue&type=style&index=0&id=2797d3b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2797d3b2",
  null
  
)

export default component.exports